'use client';

import React, { useState, useEffect } from 'react';
import Link from 'next/link';
import { usePathname } from 'next/navigation';
import Icon from '@/components/ui/AppIcon';
import Image from "next/image";
import logo from '../../../public/light-logo.svg';
interface NavigationItem {
  label: string;
  href: string;
  icon?: string;
}

interface HeaderProps {
  className?: string;
}

const Header = ({ className = '' }: HeaderProps) => {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);
  const pathname = usePathname();

  const navigationItems: NavigationItem[] = [
    { label: 'Home', href: '/homepage', icon: 'HomeIcon' },
    { label: 'Services', href: '/services-overview', icon: 'CubeIcon' },
    // { label: 'Case Studies', href: '/case-studies', icon: 'DocumentTextIcon' },
    { label: 'About', href: '/about-us', icon: 'UserGroupIcon' },
    { label: 'Careers', href: '/careers', icon: 'BriefcaseIcon' },
    { label: 'Contact', href: '/contact', icon: 'PhoneIcon' },
  ];

  const moreItems: NavigationItem[] = [
    // { label: 'Resources', href: '/resource-center', icon: 'BookOpenIcon' },
  ];

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 10);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    if (isMobileMenuOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'unset';
    }

    return () => {
      document.body.style.overflow = 'unset';
    };
  }, [isMobileMenuOpen]);

  const isActive = (href: string) => pathname === href;

  const toggleMobileMenu = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
  };

  const closeMobileMenu = () => {
    setIsMobileMenuOpen(false);
  };

  return (
    <>
      <header data-component-id="src/components/common/Header.tsx:70:6" data-component-path="src/components/common/Header.tsx" data-component-line="70" data-component-end-line="155" data-component-file="Header.tsx" data-component-name="header" data-component-content="%7B%22elementName%22%3A%22header%22%7D"
        className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
          isScrolled ? 'bg-card shadow-md' : 'bg-card'
        } ${className}`}
      >
        <div data-component-id="src/components/common/Header.tsx:75:8" data-component-path="src/components/common/Header.tsx" data-component-line="75" data-component-end-line="154" data-component-file="Header.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22container%20mx-auto%20px-4%22%7D" className="container mx-auto px-4">
          <div data-component-id="src/components/common/Header.tsx:76:10" data-component-path="src/components/common/Header.tsx" data-component-line="76" data-component-end-line="153" data-component-file="Header.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22flex%20items-center%20justify-between%20h-16%20lg%3Ah-18%22%7D" className="flex items-center justify-between h-16 lg:h-18">
            <Link data-component-id="src/components/common/Header.tsx:77:12" data-component-path="src/components/common/Header.tsx" data-component-line="77" data-component-end-line="91" data-component-file="Header.tsx" data-component-name="Link" data-component-content="%7B%22elementName%22%3A%22Link%22%2C%22href%22%3A%22%2Fhomepage%22%2C%22className%22%3A%22flex%20items-center%20space-x-3%20group%22%7D"
              href="/homepage"
              className="flex items-center space-x-3 group"
              onClick={closeMobileMenu}
            >
              <div data-component-id="src/components/common/Header.tsx:82:14" data-component-path="src/components/common/Header.tsx" data-component-line="82" data-component-end-line="90" data-component-file="Header.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22relative%22%7D" className="relative">
              <Image data-component-id="src/components/common/Header.tsx:83:14" data-component-path="src/components/common/Header.tsx" data-component-line="83" data-component-end-line="89" data-component-file="Header.tsx" data-component-name="Image" data-component-content="%7B%22elementName%22%3A%22Image%22%2C%22src%22%3A%22%5Bvar%3Alogo%5D%22%2C%22alt%22%3A%22logo%22%2C%22className%22%3A%22w-180%20dark%3Ahidden%22%7D"
                  src={logo}
                  alt="logo"
                  width={300}
                  height={57}
                  className="w-180 dark:hidden"
                />
              </div>
            </Link>

            <nav data-component-id="src/components/common/Header.tsx:93:12" data-component-path="src/components/common/Header.tsx" data-component-line="93" data-component-end-line="132" data-component-file="Header.tsx" data-component-name="nav" data-component-content="%7B%22elementName%22%3A%22nav%22%2C%22className%22%3A%22hidden%20lg%3Aflex%20items-center%20space-x-1%22%7D" className="hidden lg:flex items-center space-x-1">
              {navigationItems.map((item) => (
                <Link data-component-id="src/components/common/Header.tsx:95:16" data-component-path="src/components/common/Header.tsx" data-component-line="95" data-component-end-line="105" data-component-file="Header.tsx" data-component-name="Link" data-component-content="%7B%22elementName%22%3A%22Link%22%7D"
                  key={item.href}
                  href={item.href}
                  className={`px-4 py-2 rounded-md text-sm font-medium transition-all duration-300 ${
                    isActive(item.href)
                      ? 'bg-primary text-primary-foreground'
                      : 'text-foreground hover:bg-muted hover:text-primary'
                  }`}
                >
                  {item.label}
                </Link>
              ))}

              {/* <div className="relative group">
                <button className="px-4 py-2 rounded-md text-sm font-medium text-foreground hover:bg-muted hover:text-primary transition-all duration-300 flex items-center space-x-1">
                  <span>More</span>
                  <Icon name="ChevronDownIcon" size={16} />
                </button>
                <div className="absolute right-0 mt-2 w-48 bg-card rounded-md shadow-premium opacity-0 invisible group-hover:opacity-100 group-hover:visible transition-all duration-300 transform origin-top-right">
                  <div className="py-2">
                    {moreItems.map((item) => (
                      <Link
                        key={item.href}
                        href={item.href}
                        className={`flex items-center space-x-3 px-4 py-2 text-sm transition-colors duration-200 ${
                          isActive(item.href)
                            ? 'bg-primary text-primary-foreground'
                            : 'text-foreground hover:bg-muted hover:text-primary'
                        }`}
                      >
                        {item.icon && <Icon name={item.icon as any} size={18} />}
                        <span>{item.label}</span>
                      </Link>
                    ))}
                  </div>
                </div>
              </div> */}
            </nav>

            <div data-component-id="src/components/common/Header.tsx:134:12" data-component-path="src/components/common/Header.tsx" data-component-line="134" data-component-end-line="141" data-component-file="Header.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22hidden%20lg%3Aflex%20items-center%20space-x-3%22%7D" className="hidden lg:flex items-center space-x-3">
              <Link data-component-id="src/components/common/Header.tsx:135:14" data-component-path="src/components/common/Header.tsx" data-component-line="135" data-component-end-line="140" data-component-file="Header.tsx" data-component-name="Link" data-component-content="%7B%22elementName%22%3A%22Link%22%2C%22href%22%3A%22%2Fcontact%22%2C%22className%22%3A%22px-6%20py-2.5%20bg-primary%20text-primary-foreground%20rounded-md%20text-sm%20font-heading%20font-semibold%20hover%3Abg-primary%2F90%20transition-all%20duration-300%20shadow-subtle%20hover%3Ashadow-card%20transform%20hover%3Ascale-105%22%2C%22textContent%22%3A%22Get%20Started%22%7D"
                href="/contact"
                className="px-6 py-2.5 bg-primary text-primary-foreground rounded-md text-sm font-heading font-semibold hover:bg-primary/90 transition-all duration-300 shadow-subtle hover:shadow-card transform hover:scale-105"
              >
                Get Started
              </Link>
            </div>

            <button data-component-id="src/components/common/Header.tsx:143:12" data-component-path="src/components/common/Header.tsx" data-component-line="143" data-component-end-line="152" data-component-file="Header.tsx" data-component-name="button" data-component-content="%7B%22elementName%22%3A%22button%22%2C%22className%22%3A%22lg%3Ahidden%20p-2%20rounded-md%20text-foreground%20hover%3Abg-muted%20transition-colors%20duration-200%22%7D"
              onClick={toggleMobileMenu}
              className="lg:hidden p-2 rounded-md text-foreground hover:bg-muted transition-colors duration-200"
              aria-label="Toggle mobile menu"
            >
              <Icon data-component-id="src/components/common/Header.tsx:148:14" data-component-path="src/components/common/Header.tsx" data-component-line="148" data-component-end-line="151" data-component-file="Header.tsx" data-component-name="Icon" data-component-content="%7B%22elementName%22%3A%22Icon%22%7D"
                name={isMobileMenuOpen ? 'XMarkIcon' : 'Bars3Icon'}
                size={24}
              />
            </button>
          </div>
        </div>
      </header>

      {isMobileMenuOpen && (
        <div data-component-id="src/components/common/Header.tsx:158:8" data-component-path="src/components/common/Header.tsx" data-component-line="158" data-component-end-line="207" data-component-file="Header.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22fixed%20inset-0%20bg-background%20z-40%20lg%3Ahidden%22%7D"
          className="fixed inset-0 bg-background z-40 lg:hidden"
          style={{ top: '64px' }}
        >
          <nav data-component-id="src/components/common/Header.tsx:162:10" data-component-path="src/components/common/Header.tsx" data-component-line="162" data-component-end-line="206" data-component-file="Header.tsx" data-component-name="nav" data-component-content="%7B%22elementName%22%3A%22nav%22%2C%22className%22%3A%22container%20mx-auto%20px-4%20py-6%20flex%20flex-col%20space-y-2%22%7D" className="container mx-auto px-4 py-6 flex flex-col space-y-2">
            {navigationItems.map((item) => (
              <Link data-component-id="src/components/common/Header.tsx:164:14" data-component-path="src/components/common/Header.tsx" data-component-line="164" data-component-end-line="176" data-component-file="Header.tsx" data-component-name="Link" data-component-content="%7B%22elementName%22%3A%22Link%22%7D"
                key={item.href}
                href={item.href}
                onClick={closeMobileMenu}
                className={`flex items-center space-x-3 px-4 py-3 rounded-md text-base font-medium transition-all duration-300 ${
                  isActive(item.href)
                    ? 'bg-primary text-primary-foreground'
                    : 'text-foreground hover:bg-muted hover:text-primary'
                }`}
              >
                {item.icon && <Icon data-component-id="src/components/common/Header.tsx:174:30" data-component-path="src/components/common/Header.tsx" data-component-line="174" data-component-end-line="174" data-component-file="Header.tsx" data-component-name="Icon" data-component-content="%7B%22elementName%22%3A%22Icon%22%7D" name={item.icon as any} size={20} />}
                <span data-component-id="src/components/common/Header.tsx:175:16" data-component-path="src/components/common/Header.tsx" data-component-line="175" data-component-end-line="175" data-component-file="Header.tsx" data-component-name="span" data-component-content="%7B%22elementName%22%3A%22span%22%7D">{item.label}</span>
              </Link>
            ))}

            <div data-component-id="src/components/common/Header.tsx:179:12" data-component-path="src/components/common/Header.tsx" data-component-line="179" data-component-end-line="179" data-component-file="Header.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22border-t%20border-border%20my-4%22%7D" className="border-t border-border my-4"></div>

            {moreItems.map((item) => (
              <Link data-component-id="src/components/common/Header.tsx:182:14" data-component-path="src/components/common/Header.tsx" data-component-line="182" data-component-end-line="194" data-component-file="Header.tsx" data-component-name="Link" data-component-content="%7B%22elementName%22%3A%22Link%22%7D"
                key={item.href}
                href={item.href}
                onClick={closeMobileMenu}
                className={`flex items-center space-x-3 px-4 py-3 rounded-md text-base font-medium transition-all duration-300 ${
                  isActive(item.href)
                    ? 'bg-primary text-primary-foreground'
                    : 'text-foreground hover:bg-muted hover:text-primary'
                }`}
              >
                {item.icon && <Icon data-component-id="src/components/common/Header.tsx:192:30" data-component-path="src/components/common/Header.tsx" data-component-line="192" data-component-end-line="192" data-component-file="Header.tsx" data-component-name="Icon" data-component-content="%7B%22elementName%22%3A%22Icon%22%7D" name={item.icon as any} size={20} />}
                <span data-component-id="src/components/common/Header.tsx:193:16" data-component-path="src/components/common/Header.tsx" data-component-line="193" data-component-end-line="193" data-component-file="Header.tsx" data-component-name="span" data-component-content="%7B%22elementName%22%3A%22span%22%7D">{item.label}</span>
              </Link>
            ))}

            <div data-component-id="src/components/common/Header.tsx:197:12" data-component-path="src/components/common/Header.tsx" data-component-line="197" data-component-end-line="205" data-component-file="Header.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22pt-4%22%7D" className="pt-4">
              <Link data-component-id="src/components/common/Header.tsx:198:14" data-component-path="src/components/common/Header.tsx" data-component-line="198" data-component-end-line="204" data-component-file="Header.tsx" data-component-name="Link" data-component-content="%7B%22elementName%22%3A%22Link%22%2C%22href%22%3A%22%2Fcontact%22%2C%22className%22%3A%22block%20w-full%20px-6%20py-3%20bg-primary%20text-primary-foreground%20rounded-md%20text-base%20font-heading%20font-semibold%20text-center%20hover%3Abg-primary%2F90%20transition-all%20duration-300%20shadow-subtle%22%2C%22textContent%22%3A%22Get%20Started%22%7D"
                href="/contact"
                onClick={closeMobileMenu}
                className="block w-full px-6 py-3 bg-primary text-primary-foreground rounded-md text-base font-heading font-semibold text-center hover:bg-primary/90 transition-all duration-300 shadow-subtle"
              >
                Get Started
              </Link>
            </div>
          </nav>
        </div>
      )}
    </>
  );
};

export default Header;